import { Accordion, AccordionControl, AccordionItem, AccordionPanel, Button } from '@mantine/core';

export function HomeFaq({ ...props }) {
  return (
    <>
      <Accordion
        variant="separated"
        radius="md"
        styles={{
          item: { backgroundColor: '#F8F8FF', borderColor: '#F8F8FF', borderWidth: 2 },
          label: { fontWeight: 600, color: 'b' },
        }}
        {...props}
      >
        <AccordionItem value="1" mb="md">
          <AccordionControl px={'lg'} py={'sm'} pb={0}>
            Hisselitapu.com nasıl çalışır?
          </AccordionControl>
          <AccordionPanel bg="white" c={'black'} pt={'sm'} fz={'sm'}>
            Hisselitapu.com, gayrimenkullerin hisselere bölünerek birden fazla kişinin aynı mülke tapuda ortak olmasını sağlayan
            bir platformdur. Yatırımcılar seçtikleri mülkten pay satın alır, tapuda resmi malik olarak yer alır ve mülk yönetim
            süreçlerini şirket yaparak kira geliri elde eder.
          </AccordionPanel>
        </AccordionItem>
        <AccordionItem value="2" mb="sm">
          <AccordionControl px={'lg'} py={'sm'} pb={0}>
            Hisseli tapu nedir?
          </AccordionControl>
          <AccordionPanel bg="white" c={'black'} pt={'sm'} fz={'sm'}>
            Hisseli tapu, bir taşınmazın tapu kaydında birden fazla kişinin paylı malik olarak görünmesidir. Her ortağın tapuda
            belirli bir pay oranı bulunmasıyla oluşan ortaklık türüdür.
          </AccordionPanel>
        </AccordionItem>
        <AccordionItem value="3" mb="sm">
          <AccordionControl px={'lg'} py={'sm'} pb={0}>
            Mülk yönetimi nedir ve nasıl çalışır?
          </AccordionControl>
          <AccordionPanel bg="white" c={'black'} pt={'sm'} fz={'sm'}>
            Mülk yönetimi, gayrimenkulün kiralama, bakım ve gelir takibi gibi süreçlerinin profesyonel şekilde yürütülmesidir. Bu
            süreçler Hisselitapu.com tarafından organize edilir ve gelirler hisselere göre yatırımcılara dağıtılır.
          </AccordionPanel>
        </AccordionItem>
        <AccordionItem value="4" mb="sm">
          <AccordionControl px={'lg'} py={'sm'} pb={0}>
            Gayrimenkuldeki hissemi nasıl satarım?
          </AccordionControl>
          <AccordionPanel bg="white" c={'black'} pt={'sm'} fz={'sm'}>
            Sahip olduğunuz hisseyi sitede yer alan pazaryeri üzerinden ilan usulü satışa çıkarabilirsiniz. Satış işlemi resmi bir
            şekilde tamamlanır.
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </>
  );
}
